import { Component, OnInit } from '@angular/core';
import { GroupsModel } from 'src/app/models/GroupsModel';
import { GroupsService } from 'src/app/services/GroupsService';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';         ///----------- for searching pop up -----------
import { UserPermService } from 'src/app/services/UserPermService';
import { UserPermModel } from 'src/app/models/UserPermModel';
import {UsersModel} from 'src/app/models/UsersModel';
import { UsersService } from 'src/app/services/UsersService';
import { Location } from '@angular/common';
import { Time, formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { CompanyService } from 'src/app/services/CompanyService';
import { CompanyModel } from 'src/app/models/CompanyModel';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  userID ='';
  userName =this.storage.retrieve('stgusername');

CompanyName = "";

  usGroup ='';
  usAdmin = '';
  usStaff =  '';
  usOncologist = '';
  usPharma =  '';
  usAccounting = '';
  userID1 = '';
  modifiedDate = '2021-01-01';
  compCode = '1';
  wk_full = false;
  wk_Read = false;
  wk_Not = false;
  wk_Med= false;

  wk_Staff_full = false;
  wk_Staff_Read = false;
  wk_Staff_Not = false;

  wk_Oncology_full = false;
  wk_Oncology_Read = false;
  wk_Oncology_Not = false;

  wk_Pharma_full = false;
  wk_Pharma_Read = false;
  wk_Pharma_Not = false;

  wk_Acc_full = false;
  wk_Acc_Read = false;
  wk_Acc_Not = false;

  wk_preparationOrderLink = 'PreparationOrderNew';
  myimage;
  sellersPermitString = '';
  groupsList: GroupsModel[] =[];

  constructor(public groupsService: GroupsService,
    public userPerm: UserPermService,
    public group: UserPermModel,
    public usersService :UsersService,
    public companyservice : CompanyService,
    public storage: LocalStorageService,
    private location: Location,
    public route: Router) { }

  ngOnInit(): void {
    //this.location.replaceState('/CairoCure');
    this.companyservice.getcompany(this.storage.retrieve('stgcompCode')).subscribe((data: CompanyModel) => {
        this.CompanyName = data.compName;
    });

if (localStorage.length == 0) {
        window.location.replace('/');
        return;
  // فاضي

  console.log(localStorage.length);
}


    this.retriveUserPerm();
    this.userName = " Current User : "+this.storage.retrieve('stgusername');
    this.myimage = this.storage.retrieve('stgmyImage');

    //this.storage.store('stgDocumentNumber','')
    //this.storage.store('stgPatientCode','');
    //this.storage.store('stgDocumentDate',formatDate(new Date(), 'yyyy-MM-dd', 'en'));

    if( this.myimage == null) {this.retrivePicDefult()}
    if(this.storage.retrieve('stgGroup') =='7'){this.wk_Staff_Not = true;this.wk_preparationOrderLink = 'PreparationOrderNurse'}
  }
  Exit(){

    window.location.href = "https://cairocure.com";
  }
  Prep_Order(){
     this.storage.store('stgDocumentNumber','');
    // this.storage.store('stgDocumentDate',formatDate(new Date(), 'yyyy-MM-dd', 'en'));

  }
  retriveUserPerm(){
    this.userPerm.getUserPermission(this.storage.retrieve('stgGroup'),this.storage.retrieve('stgcompCode')).subscribe((data: UserPermModel) => {
      this.usGroup = data.usGroup;
      this.usAdmin = data.usAdmin;
      this.usStaff = data.usStaff;
      this.usOncologist = data.usOncologist;
      this.usPharma = data.usPharma;
      this.usAccounting = data.usAccounting;
      this.compCode = data.compCode;
      this.userID1 = data.userID;
      this.modifiedDate = data.modifiedDate;

      if (this.usAdmin=="Full") this.wk_full = true;
      if (this.usAdmin=="Read") this.wk_Read = true;
      if (this.usAdmin=="Not") this.wk_Not = true;

      if (this.usStaff=="Full") {this.wk_Staff_full = true;}
      if (this.usStaff=="Read") {this.wk_Staff_Read = true;}
      if (this.usStaff=="Not") {this.wk_Staff_Not = true;};
      this.storage.store('wk_Staff_Read', this.wk_Staff_Read);

      if (this.usOncologist=="Full") {this.wk_Oncology_full = true;}
      if (this.usOncologist=="Read") {this.wk_Oncology_Read = true;}
      if (this.usOncologist=="Not") {this.wk_Oncology_Not = true;}
      this.storage.store('wk_Oncology_Read', this.wk_Oncology_Read);


      if (this.usPharma=="Full") this.wk_Pharma_full = true;
      if (this.usPharma=="Read") this.wk_Pharma_Read = true;
      if (this.usPharma=="Not") this.wk_Pharma_Not = true;
      this.storage.store('wk_Oncology_Read', this.wk_Oncology_Read);

      if (this.usAccounting=="Full") this.wk_Acc_full = true;
      if (this.usAccounting=="Read") this.wk_Acc_Read = true;
      if (this.usAccounting=="Not") this.wk_Acc_Not = true;
      this.storage.store('wk_Acc_Read', this.wk_Acc_Read);


    }
    );
    if(this.storage.retrieve('stgGroup') =='3'){this.wk_Oncology_Not =true};

  }
  retrivePicDefult(){
    this.usersService.getDefultPic('evan', '1').subscribe((data: UsersModel) => {
    this.myimage = data.iTPicture;
    this.sellersPermitString =  data.iTPicture;
    this.myimage =this.sellersPermitString;
    this.storage.store('stgmyImage', this.myimage);
    var kk = this.sellersPermitString;
   });
}
Dbank(){
  this.storage.store('stgPatientCode','')
}
DoctorObservation(){
  this.storage.store('stgPatientCode','0000')
  this.storage.store('stgPatientName','')
}
Contacts(){
  this.storage.store('stgPatientCode','');
}
Supplier(){
  this.storage.store('stgPatientCode','');
}
Doctors(){
  this.storage.store('stgPatientCode','');
}
ClinicalPharmacyFollowUp(){
  this.storage.store('stgParD1', formatDate(new Date(), 'yyyy-MM-dd', 'en'));
  this.storage.store('stgParD2', formatDate(new Date(), 'yyyy-MM-dd', 'en'));
  this.route.navigate(['report-vewier', 'CocReports/NursingFollowUp']);
}

Check_Log_Out(){
    // if (localStorage.length === 0) {
    //   localStorage.clear();
    //   window.location.replace('');

    // }
    sessionStorage.removeItem("token");
localStorage.clear();
this.route.navigate(['']);
}
  Log_Out(){

sessionStorage.removeItem("token");
localStorage.clear();
this.route.navigate(['']);

console.log('john');

}
}
